import { useCommon } from "../../Hooks/Common/useCommon";
import { AgGridReact } from "@ag-grid-community/react";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import DatePicker from "react-multi-date-picker";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { SkeletonDataTable } from "../Loader/Loader";
import RequestPopup from "./RequestPopup";
import { useJenkisRequestList } from "../../Hooks/Features/HelpDesk/useJenkisRequestList";
import { expriryData, handleDurationSelect } from "../../utils/Helper";
import { useTheme } from "../../context/ThemeContext";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
const JenkisRequestList = () => {
    const { theme } = useTheme();
    const { loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, approval, setApproval, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, handleRequest, editData, setEditData, GetJenkinsEnvType, showInfo } = useJenkisRequestList({ fromReport: false });
    const { checkPermission } = useCommon();

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "helpdesk", "data": "jenkins_tab"}' >
                <div className="row sk-header-row">
                    <div className="col-md-6 col-12">
                        <div className="row gx-3">
                            <div className="col-md-2 col-12">
                                <CommonFilterDropdown
                                    fields={[
                                        { key: "projects", label: "Projects", col: 12, type: "dropdown" },
                                    ]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues} />
                            </div>
                            <div className="col-md-2 col-12">
                                <MultiSelect
                                    options={dropDownOption?.envOption}
                                    optionLabel="environment_name"
                                    placeholder="Environment"
                                    title="Environment"
                                    value={filterValues.environment}
                                    onChange={(e) => setFilterValues((prev) => ({ ...prev, environment: e.target.value, isChange: true }))}
                                    onHide={() => { if (filterValues?.isChange) { getRequestedData(); GetJenkinsEnvType(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                                    filter filterInputAutoFocus
                                    className="sk-multiselect"
                                    panelClassName="sk-multiselect-panel"
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'environment', filterValues.environment, (val) => setFilterValues((prev) => ({ ...prev, environment: val })), () => {
                                        setFilterValues((prev) => ({ ...prev, isChange: false, apiCall: true, jenkinstype: [], jenkinsSubtype: [], jenkinsJob: [] }));
                                    })}
                                />
                            </div>
                            <div className="col-md-2 col-12">
                                <MultiSelect
                                    options={dropDownOption?.jenkinsTypeOption}
                                    optionLabel="jenkins_type_name"
                                    placeholder="Jenkins Type"
                                    title="Jenkins Type"
                                    value={filterValues.jenkinstype}
                                    onChange={(e) => setFilterValues((prev) => ({ ...prev, jenkinstype: e.target.value, isChange: true }))}
                                    onHide={() => { if (filterValues?.isChange) { getRequestedData(); GetJenkinsEnvType(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                                    filter filterInputAutoFocus
                                    className="sk-multiselect"
                                    panelClassName="sk-multiselect-panel"
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'project', filterValues.jenkinstype, (val) => setFilterValues((prev) => ({ ...prev, jenkinstype: val })), () => {
                                        setFilterValues((prev) => ({ ...prev, isChange: false, apiCall: true, jenkinsSubtype: [], jenkinsJob: [] }));
                                    })}
                                />
                            </div>
                            <div className="col-md-2 col-12">
                                <MultiSelect
                                    options={dropDownOption?.jenkinsSubTypeOption}
                                    optionLabel="sub_type_name"
                                    placeholder="Sub Type"
                                    title="Sub Type"
                                    value={filterValues.jenkinsSubtype}
                                    onChange={(e) => setFilterValues((prev) => ({ ...prev, jenkinsSubtype: e.target.value, isChange: true }))}
                                    onHide={() => { if (filterValues?.isChange) { getRequestedData(); GetJenkinsEnvType(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                                    filter filterInputAutoFocus
                                    className="sk-multiselect"
                                    panelClassName="sk-multiselect-panel"
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'jenkinsSubtype', filterValues.jenkinsSubtype, (val) => setFilterValues((prev) => ({ ...prev, jenkinsSubtype: val })), () => {
                                        setFilterValues((prev) => ({ ...prev, isChange: false, apiCall: true, jenkinsJob: [] }));
                                    })}
                                />
                            </div>
                            <div className="col-md-2 d-flex align-items-center flex-wrap gap-2 col-12">
                                <MultiSelect
                                    options={dropDownOption?.jenkinsJobTypeOption}
                                    optionLabel="job_name"
                                    placeholder="Job"
                                    title="Job"
                                    value={filterValues.jenkinsJob}
                                    onChange={(e) => setFilterValues((prev) => ({ ...prev, jenkinsJob: e.target.value, isChange: true }))}
                                    onHide={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                                    filter filterInputAutoFocus
                                    className="sk-multiselect"
                                    panelClassName="sk-multiselect-panel"
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'jenkinsJob', filterValues.jenkinsJob, (val) => setFilterValues((prev) => ({ ...prev, jenkinsJob: val })), () => {
                                        setFilterValues((prev) => ({ ...prev, isChange: false, apiCall: true }));
                                    })}
                                />
                            </div>
                            <div className="col-md-2 col-12">
                                <CommonFilterDropdown
                                    fields={[{ key: "all_users", label: "Users", col: 12 }]}
                                    filterValues={filterValues}
                                    setFilterValues={setFilterValues} />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between col-md-6 col-12">
                        <div className="w30">
                            <DatePicker
                                value={filterValues?.hoveredRange}
                                onChange={(e) => { setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true })); }}
                                range
                                rangeHover
                                placeholder="Select Date"
                                onClose={() => { if (filterValues?.isChange) { getRequestedData(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                            />
                        </div>
                        <div className="d-flex align-items-center flex-wrap w50">
                            {dropDownOption?.statusOptions?.map((item) => (
                                <div
                                    key={item.request_status_id}
                                    className="d-flex justify-content-center align-items-center"
                                >
                                    <input
                                        type="radio"
                                        id={item.request_status_id}
                                        name="status"
                                        value={item.request_status_id}
                                        onChange={(e) => handleStatusChange(e)}
                                        checked={
                                            filterValues.status?.request_status_id ===
                                            item.request_status_id
                                        }
                                        className="sk-radio"
                                    />
                                    <label htmlFor={item.request_status_id} className="sk-radio-label">
                                        {item.request_status_name}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div className="col-md-2 d-flex gap-2 justify-content-end col-12">
                            <button className="sk-btn sk-btn-primary" onClick={() => getRequestedData()}><i className="icon-refresh-outline" /> </button>
                            <button className="sk-btn sk-btn-primary" onClick={() => setShowRequestPopup(true)}><i className="icon-add-outline" /> </button>
                        </div>
                    </div>
                </div>
                <div ref={() => checkPermission("help desk", tagRef)}>
                    <div ref={tagRef} id='{"tabname": "helpdesk", "data": "helpdesk_action_col"}' >
                        <div className="d-flex justify-content-end gap-2 ">
                            <button className="sk-btn sk-btn-primary " onClick={() => {
                                const data = rowData?.filter(item => item.is_checked === true)?.map(item => item.jenkins_request_id)
                                if (data?.length <= 0 || !data) {
                                    showInfo("Info", "Please select a request to approve");
                                    return
                                }
                                setShowApprovePopup(true);
                                setApproval((prevState) => ({ ...prevState, data, status: "is_approved", selectedRadio: "" }))
                            }}>Approve All</button>

                            <button className="sk-btn sk-btn-danger " onClick={() => handleRequest("is_rejected", rowData?.filter(item => item.is_checked === true)?.map(item => item.jenkins_request_id))}>Reject All</button>
                        </div>
                    </div>
                </div>
                {loader ? <div><SkeletonDataTable numSkeletons={15} /></div> :
                    <div className={`sk-ag-grid ${theme === 'dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}`} style={{ height: "calc(100vh - 110px)" }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowHeight={30}
                            headerHeight={30}
                        />
                    </div>
                }
                <Dialog visible={showApprovePopup} header="Approve Request" onHide={() => {
                    setShowApprovePopup(false);
                }} className="modal-small" draggable={false}>
                    <div className="">
                        <div className="w-50 inspectra-calendar">
                            <span>
                                Expiry Date
                            </span>
                            <Calendar value={approval?.expiryDate}
                                className="input-dd"
                                onChange={(e) => setApproval((prev) => ({ ...prev, expiryDate: e.target.value, selectedRadio: "" }))}
                                dateFormat='dd-mm-yy' placeholder="Select date"
                                minDate={new Date()}
                                maxDate={new Date(new Date().setMonth(new Date().getMonth() + 3))}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center text-center my-2" >
                        <hr style={{ flex: 1, }} className="border-top border-secondary" />
                        <span style={{ padding: '0 10px', color: '#666' }}>OR</span>
                        <hr style={{ flex: 1, }} className="border-top border-secondary" />
                    </div>
                    <div>
                        <div className="">
                            Expiry Duration
                        </div>
                        {expriryData?.map((d) => (
                            <div className="form-check-inline" key={d.value}>
                                <input
                                    type="radio"
                                    id={d.value}
                                    name="duration"
                                    value={d.value}
                                    checked={d.value === approval?.selectedRadio}
                                    onChange={(e) => setApproval((prev) => ({ ...prev, expiryDate: handleDurationSelect(d.value), selectedRadio: d.value }))}
                                    className="sk-radio"
                                />
                                <label htmlFor={d.value} className="sk-radio-label">
                                    {d.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex gap-2 justify-content-center my-4" >
                        <button className="sk-btn sk-btn-primary"
                            onClick={() => handleRequest(null)}
                        > Confirm </button>
                        <button
                            onClick={() => {
                                setShowApprovePopup(false)
                            }}
                            className="sk-btn sk-btn-primary">
                            Cancel
                        </button>
                    </div>
                </Dialog>
                {
                    showRequestPopup && <RequestPopup showRequestPopup={showRequestPopup} setShowRequestPopup={setShowRequestPopup} editData={editData} setEditData={setEditData} callApi={getRequestedData} type="jenkins_tab" />
                }
            </div>
        </div>
    )
}

export default JenkisRequestList
